import { IMedia } from "@common/models/CMS";
import { FC } from "react";
import { useHistory } from "react-router";
import OptimizedImage from "./general/OptimizedImage";

interface IRelativePagePanelProps {
    title: string;
    imageUrl: IMedia;
    description: string;
    redirectUrl: string;
    className?: string;
}

const RelativePagePanel: FC<IRelativePagePanelProps> = ({ description, imageUrl, redirectUrl, title, className }) => {
    const { push } = useHistory();

    return (
        <section className={`relative-page-panel${className ? ` ${className}` : ""}`} onClick={() => push(redirectUrl)}>
            <div className="background-relative-panel">
                <OptimizedImage source={imageUrl} />
            </div>
            <article className="article-relative-panel">
                <h2 className="header-text text-center mb-3 mb-sm-0">{title}</h2>
                <div className="description text-center">{description}</div>
            </article>
        </section>
    )
}

export default RelativePagePanel;